import React from 'react';

export const ErrorComponent: React.FC = () => {
  return <p>An Error Occurred, please try again or after some time.</p>;
};
